import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["list", "more", "remaining"];
  static values = { url: String, total: Number };

  declare readonly listTarget: HTMLElement;
  declare readonly moreTarget: HTMLButtonElement;
  declare readonly remainingTarget: HTMLElement;
  declare readonly urlValue: string;
  declare readonly totalValue: number;

  async more(): Promise<void> {
    const button = this.moreTarget;
    button.disabled = true;

    try {
      const response = await fetch(`${this.urlValue}?offset=${this.shownCount()}`, {
        headers: { Accept: "text/html", "X-Requested-With": "XMLHttpRequest" },
        credentials: "same-origin",
      });
      if (!response.ok) return;

      const html = await response.text();
      const before = this.shownCount();
      this.listTarget.insertAdjacentHTML("beforeend", html);
      const remaining = this.totalValue - this.shownCount();

      if (remaining <= 0 || this.shownCount() === before) button.remove();
      else this.remainingTarget.textContent = String(remaining);
    } finally {
      button.disabled = false;
    }
  }

  private shownCount(): number {
    return this.listTarget.querySelectorAll(":scope > .tl-item").length;
  }
}
